import React from 'react';
import './Preload.css'

import StudioLogo from '../../Assets/Imgs/StudioLogo.svg'
import Eui from '../../Assets/Imgs/Eui.svg'

import LoadBase from '../../Assets/Imgs/LoadingBase.png'
import LoadBar from '../../Assets/Imgs/LoadingBar.png'
import LoadRing from '../../Assets/Imgs/LoadingRing.png'

const Preload = () => {
    return ( 
        <div className='Preload'>
            <img className='StudioLogo' src={StudioLogo} alt="" />

            <img className='Eui' src={Eui} alt="" />

            <div className='LoadingBar'>
                <img className='LoadBase' src={LoadBase} alt="" />
                <div className='BarContainer'>
                    <img className='LoadBar' src={LoadBar} alt="" />
                </div>
                <img className='LoadRing' src={LoadRing} alt="" />
            </div>
        </div>
     );
}
 
export default Preload;